<template>
    <div class="row">
        <div class="col-md-4 col-md-push-8 order-md-8">
            <div :class="boxClass.box">
                <div v-if="theme=='bs3' || theme=='evt'" :class="boxClass.boxHeader">Product Selection</div>
                <h5 v-else class="card-header">Product Selection</h5>
                <div :class="[boxClass.boxBody, boxClass.noPadding]">
                    <sku-picker
                        :product-prop='product'
                        :show-button="false"
                        :theme="theme">
                    </sku-picker>
                </div>
            </div>
        </div>
        <div class="col-md-8 col-md-pull-4 order-md-4">

            <div v-if="user==null || !user.id">
                <div :class="boxClass.box">
                    <div :class="[boxClass.boxHeader]">
                        Enter your email addresss
                    </div>
                    <div :class="[boxClass.boxBody]">
                        <login-or-signup
                            @authenticated="authenticated"
                            :theme="loginTheme"
                            :participant-user-authentication-strategy="authenticationStrategy">
                        </login-or-signup>
                    </div>
                </div>
            </div>

            <div :class="boxClass.box">
                <div v-if="theme=='bs3' || theme=='evt'" :class="boxClass.boxHeader">Additional Details</div>
                <h5 v-else class="card-header">Order Form</h5>
                <div :class="boxClass.boxBody">
                    <strong>Selected Products:</strong>
                    <ul v-for="(sku, index) in product.skus">
                        <template v-if="sku.quantity > 0">
                            <li>{{ sku.name }} x {{ sku.quantity }}</li>
                        </template>
                    </ul>
                    <div v-if="product.include_customer_note" class="mt-4">
                        <strong>Note (optional):</strong>
                        <b-form-textarea
                            id="textarea"
                            v-model="order_details.customer_note"
                            placeholder="Enter your note"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>

                    </div>

                    <hr>

                    <fieldset :disabled="user==null || !user.id">

                        <div class="form-group" v-if="showMembersSelect">
                            <label>Member:</label>

                            <select
                                class="form-control"
                                name="member"
                                v-model="order_details.member_id"
                                v-on:change="memberChanged()">
                                <option value="">Select member</option>
                                <option v-for="member in members" v-bind:value="member.id">
                                    {{ member.fullname }}
                                </option>
                            </select>

                        </div>


                        <div class="form-group">
                            <label>Email address</label>

                            <input v-validate="'required'"
                                   type="text"
                                   name="email"
                                   class="form-control"
                                   v-model="order_details.email">
                            <small
                                v-show="vErrors.has('email')"
                                class="text-danger">
                                {{ vErrors.first('email') }}
                            </small>

                        </div>

                        <div class="form-group">
                            <label>First
                                name</label>

                            <input v-validate="'required'"
                                   data-vv-as="first name"
                                   type="text"
                                   name="first_name"
                                   class="form-control"
                                   v-model="order_details.first_name">
                            <small
                                v-show="vErrors.has('first_name')"
                                class="text-danger">
                                {{ vErrors.first('first_name') }}
                            </small>

                        </div>

                        <div class="form-group">
                            <label>Last
                                name</label>

                            <input v-validate="'required'"
                                   data-vv-as="last name"
                                   type="text"
                                   name="last_name"
                                   class="form-control"
                                   v-model="order_details.last_name">
                            <small
                                v-show="vErrors.has('last_name')"
                                class="text-danger">
                                {{ vErrors.first('last_name') }}
                            </small>

                        </div>

                        <div v-if="product.request_address">

                            <div class="form-group">
                                <label>Address
                                    line 1</label>

                                <input v-validate="'required'"
                                       data-vv-as="address line 1"
                                       type="text"
                                       name="address_line_1"
                                       class="form-control"
                                       v-model="order_details.address_line_1">
                                <small
                                    v-show="vErrors.has('address_line_1')"
                                    class="text-danger">
                                    {{ vErrors.first('address_line_1') }}
                                </small>
                            </div>


                            <div class="form-group">
                                <label>Address line 2</label>
                                <input type="text"
                                       name="address_line_2"
                                       class="form-control"
                                       v-model="order_details.address_line_2">
                            </div>

                            <div class="form-group">
                                <label>Town</label>

                                <input v-validate="'required'"
                                       type="text"
                                       name="town"
                                       class="form-control"
                                       v-model="order_details.address_town">
                                <small
                                    v-show="vErrors.has('town')"
                                    class="text-danger">
                                    {{ vErrors.first('town') }}
                                </small>

                            </div>

                            <country-input
                                v-model="order_details.address_country"
                            ></country-input>
                            <post-code-input
                                :country="order_details.address_country"
                                v-model="order_details.address_zip"
                            ></post-code-input>
                        </div>

                        <input
                            type="submit"
                            value="Add To Basket"
                            class="btn btn-ar btn-block btn-success"
                            v-on:click="submitButton()">
                    </fieldset>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {CountryData} from "../../../config";
import CountryInput from '../../Utility/Forms/InputFields/CountryInput.vue';
import PostCodeInput from '../../Utility/Forms/InputFields/PostCodeInput.vue';
import LoginOrSignup from '../../Users/LoginOrSignup/LoginOrSignup.vue'
import PlusMinusControl from '../../AAA_TO_REFACTOR/PlusMinsControl.vue'
import SkuPicker from '../../AAA_TO_REFACTOR/SkuPicker.vue'

export default {
    name: "order",
    props: {
        edit: {
            type: Boolean,
            default: false
        },
        userProp: {
            type: Object,
            default: null
        },
        orderProp: {
            type: Object,
            default: () => ({})
        },
        product: {
            type: Object,
            default: () => ({})
        },
        theme: {
            type: String,
            default: 'bs3'
        },
        authenticationStrategy: {
            type: String,
            default: 'guest_login'
        },
    },
    components: {
        CountryInput,
        PostCodeInput,
        PlusMinusControl,
        LoginOrSignup,
        SkuPicker
    },
    filters: {},
    data() {
        return {
            user: {},

            order_details: {
                email: '',
                first_name: '',
                last_name: '',
                address_line_1: '',
                address_line_2: '',
                address_town: '',
                address_state: '',
                address_zip: '',
                address_country: CountryData.GBR.name,
                member_id: '',
                customer_note: ''
            },

            members: [],
        }
    },
    computed: {
        boxClass() {
            if (this.theme == 'bs3') {
                return {
                    box: 'panel panel-default',
                    boxHeader: 'panel-heading',
                    boxBody: 'panel-body',
                    noPadding: 'no-padding'
                }

            } else if (this.theme == 'evt') {
                return {
                    box: 'box box-default',
                    boxHeader: 'box-header with-border',
                    boxBody: 'box-body',
                    noPadding: 'no-padding'
                }
            } else {
                return {
                    box: 'card card-default',
                    boxHeader: 'card-header',
                    boxBody: 'card-body',
                    noPadding: 'px-0 py-0'
                }
            }
        },
        loginTheme() {
            if (this.theme == "evt") {
                return "bs3";
            }

            return "bs4";
        },
        showMembersSelect() {
            return this.members !== undefined && this.members.length > 1;
        }
    },
    created() {

        this.user = this.userProp;

        if (this.user !== null) {
            this.authenticated(this.user);
        }



        // if this is an edit populate the details from one of the orders provided
        if (this.edit) {
            this.order_details.user_id = this.user !== null ? this.user.id : null;
            this.order_details.email = this.orderProp.email;
            this.order_details.first_name = this.orderProp.first_name;
            this.order_details.last_name = this.orderProp.last_name;
            this.order_details.address_line_1 = this.orderProp.address_line_1;
            this.order_details.address_line_2 = this.orderProp.address_line_2;
            this.order_details.address_town = this.orderProp.address_town;
            this.order_details.address_state = this.orderProp.address_state;
            this.order_details.address_zip = this.orderProp.address_zip;
            this.order_details.address_country = this.orderProp.address_country;

            this.order_details.member_id = this.orderProp.member_id == null ? '' : this.orderProp.member_id;

        } else if (this.showMembersSelect) {

            // if there is only one member use their details
            this.order_details.email = this.members[0].email;
            this.order_details.first_name = this.members[0].first_name;
            this.order_details.last_name = this.members[0].last_name;

        }


    },
    methods: {
        submitButton() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    axios({
                        method: 'POST',
                        url: '/api/v0/orders/bulk',
                        data: {
                            'orderDetails': this.order_details,
                            'product': this.product,
                            'identifier': this.edit ? this.orderProp.identifier : '', // identifier for edit to match existing records
                        },
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        }
                    }).then((response) => {
                        window.location.href = '/order-summary'
                    }).catch((error) => {
                        alert('Failed to place order');
                    });

                }

            });

        },
        authenticated(user) {
            this.user = user;

            console.log('running user authenticated');

            // if this isnt an edit populate the details from the user
            if (!this.edit) {
                this.order_details.email = user.email;
                this.order_details.first_name = user.first_name;
                this.order_details.last_name = user.last_name;
            }

            this.order_details.user_id = user.id;


            // get members
            axios.get(this.dataUrlPrefix + '/api/v0/users/' + user.id + '/members', {
                headers: {
                    'Accept': 'application/json'
                }
            }).then((response) => {
                this.members = response.data.data.members;
            });
        },
        /**
         * populate the member details when the member is changed
         */
        memberChanged() {

            this.members.forEach((member, i) => {
                if (member.id === this.order_details.member_id) {
                    this.order_details.email = member.email;
                    this.order_details.first_name = member.first_name;
                    this.order_details.last_name = member.last_name;
                    this.order_details.member_id = member.id;
                }
            });

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Orders/Form/Default.vue